import { createAttachmentNodeSpec, createImageNodeSpec, createVideoNodeSpec, } from "./nodes";
import { fakeFilestackExtensionService } from "./service/fake-filestack-extension.service";
export function filestackNodeSpecs(service = fakeFilestackExtensionService) {
    return {
        attachment: createAttachmentNodeSpec(service),
        image: createImageNodeSpec(service),
        video: createVideoNodeSpec(service),
    };
}
